export const setDarkMode = (state, darkMode) => {
  return { darkMode };
};
